module.exports = __webpack_public_path__ + "img/11.d8ea9de8.jpg";